export default __webpack_public_path__ + "static/media/banner4.666c6780.jpg";